export default __webpack_public_path__ + "static/media/chapter6.fb4b3336.jpg";